import { useEffect, useState } from "react";

const G = "https://static.prod-images.emergentagent.com/jobs/bc9636e8-770f-424d-8d89-08b8e8675941/images/";
export const GEN = {
  hero: G + "34e9ec6933a20da2b9df882b5ede4400b7df90aead0010046817d4548f658997.jpeg",
  optimist: G + "183bee204d978ba3716be7f96a4c1970b3d647ad0c52083c0d6377ab9457015e.jpeg",
  ilca: G + "0b5bd612390cb53864b5725a932b016fc84449879b93f2fd62541bf22b0d147a.jpeg",
  "420": G + "6e200b66c63ddc9bcd12e4c631e7b304af6255eebdd5f539e40f3246ed36bac7.jpeg",
  "29er": G + "31d47d042f626ff1fad42cdff9ba804ca77362583c35d76131a52fb9794aa8f0.jpeg",
  charter: G + "4bcf489f6b9d814de79edbbba247e5c8ba360555749b4926c0926674e69f054b.jpeg",
  coach: G + "c9625975b0dbec2de936705b8c6004fff23eb8ea8508393bfde080adc776c6f5.jpeg",
  marina: G + "f7ad80c7beb026f87c67938170b99b1fb2bce6f0bbc0f7183ae2975582229ec9.jpeg",
};

export const classFallback = (name) => ((name || "").toLowerCase().startsWith("ilca") ? GEN.ilca : GEN[(name || "").toLowerCase()] || GEN.hero);
export const classesOf = (e) => (e?.class_names?.length ? e.class_names : e?.class_name ? [e.class_name] : []);

export const Img = ({ src, fallback = GEN.hero, alt = "", timeout = 6000, ...props }) => {
  const [cur, setCur] = useState(src || fallback);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setCur(src || fallback); setLoaded(false); }, [src, fallback]);
  useEffect(() => {
    if (loaded || cur === fallback) return undefined;
    const id = setTimeout(() => setCur(fallback), timeout);
    return () => clearTimeout(id);
  }, [cur, loaded, fallback, timeout]);
  return <img src={cur} alt={alt} onLoad={() => setLoaded(true)} onError={() => cur !== fallback && setCur(fallback)} {...props} />;
};
